(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dcolora-sink-model-catalog"]) return;
  try {
    
  (() => {
    const initializeCatalog = (root) => {
      if (root.dataset.catalogReady) return;
      root.dataset.catalogReady = 'true';
      const input = root.querySelector('[data-catalog-search]');
      const rows = Array.from(root.querySelectorAll('[data-catalog-row]'));
      const normalize = (value) => value.toLowerCase().replace(/[^a-z0-9]/g, '');
      const entries = rows.map((row) => ({ row, text: normalize(row.dataset.catalogSearchText) }));
      const count = root.querySelector('[data-catalog-count]');
      const empty = root.querySelector('[data-catalog-empty]');
      let timer;
      const filter = () => {
        const query = normalize(input.value);
        let matches = 0;
        entries.forEach(({ row, text }) => {
          row.hidden = !text.includes(query);
          if (!row.hidden) matches += 1;
        });
        count.textContent = String(matches);
        empty.hidden = matches !== 0;
      };
      input.addEventListener('input', () => {
        clearTimeout(timer);
        timer = setTimeout(filter, 120);
      });
      root.querySelector('[data-catalog-clear]').addEventListener('click', () => {
        clearTimeout(timer);
        input.value = '';
        filter();
        input.focus();
      });
      root.querySelector('[data-catalog-tools]').hidden = false;
    };
    const initialize = () => document.querySelectorAll('[data-dc-model-catalog]').forEach(initializeCatalog);
    initialize();
    document.addEventListener('shopify:section:load', initialize);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
